import { useState, useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import _ from "lodash"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { Grid, Typography, IconButton, Box } from "@material-ui/core"
import { Add as AddIcon, Close as CloseIcon, KeyboardArrowDown } from "@material-ui/icons"
import { documentsActions } from "../../actions/documentsActions"
import { operationsHelper } from "../../helpers/operations"
import { dataHelper } from "../../helpers/dataextraction"
import axios from "../../services/axios"
import { getCommentsCount, LIST_VIEW, METADATA } from "../../utils"
import { getDocumentsRequest, updateMetadata } from "../../actions/viewdocumentsActions"
import { getDocumentRowClickRequest } from "../../actions/documentModalActions"
import { useDebounce, PAGINATION_DELAY, DEFAULT_PAGE_SIZE, PAGE_OPTIONS } from "../../utils"
import TableView from "../../components/common/TableView/TableView"
import DocumentModal from "../../components/common/DocumentModal"
import { getAllDocumentsTableColumns } from ".."
import CreateTag from "../../components/tags/CreateTag"
import TagSelect from "../../components/tags/TagSelect"
import EmailDialog from "../../components/common/dialog/Simple"
import { setReviewAsignee, setReviewAssigneeMap } from "../../actions/reviewActions"
import { requestCustomTags, tagButtonClickedReset } from "../../actions/customTagsActions"
import MultiTagView from "../../components/multiTag/MultiTagView"
import ShowAllTags from "../../components/multiTag/ShowAllTags"
import DownloadAs from "../../components/common/dialog/DownloadAs"
import TaggedDate from "../../components/taggedDate/TaggedDate"
import TaggedDateDialog from "../../components/common/dialog/TaggedDateDialog"

export const AllDocumentsList = ({
	elementsFilter,
	filtersButton,
	setDocumentslist,
	filterList,
	filterDate,
	needToFilter,
	setNeedToFilter,
	page,
	setPage,
	pageCount,
	setPageCount,
	recordsPerPage,
	setRecordsPerPage,
	isEmailType,
	isAllDocsViewSelected,
	sortModel,
	setSortModel,
	toRetainFilterLoading = false,
	selectedSearch,
}) => {
	const SERVER_MODE = "server"
	// Translation
	const [t] = useTranslation("global")
	// Theme
	const theme = useTheme()
	/* ******************* REDUX STORE ******************* */
	//Redux actions
	const dispatch = useDispatch()
	const allDocuments = useSelector((state) => state.viewdocuments.allDocuments)
	const conceptDocs = useSelector((state) => state.viewdocuments.concept_docs)
	const isAlldocsLoading = useSelector((state) =>
		isAllDocsViewSelected ? state.viewdocuments.allDocumentsLoading : state.viewdocuments.loading
	)
	const allDocumentsCount = useSelector((state) => state.viewdocuments.allDocumentsCount)
	const conceptsDocCount = useSelector((state) => state.viewdocuments.concept_docs.count)
	const conceptsDocLoading = useSelector((state) => state.viewdocuments.loading)
	const documentLoadingInBackground = useSelector((state) => state.viewdocuments.allDocumentsLoadingInBackground)
	const viewDocument = useSelector((state) => state.viewdocuments.document)
	const conceptsOfSearch = useSelector((state) => state.viewdocuments.currentConceptTargetTerms)
	//Access store state
	const alert = useSelector((state) => state.alert.alert)
	const downloadDocs = useSelector((state) => state.downloads.documents)
	const tagsApi = useSelector((state) => state.tags.custom_tags)
	const { tagButtonClicked } = useSelector((state) => state.tags)
	const { tagggedDateButtonClicked } = useSelector((state) => state.taggedDateReducers)

	const updateCommentsRequest = useSelector((state) => state.document.reloadComments)
	const comentsCount = useSelector((state) => state.document.doc_counts)
	const selectedBaseId = useSelector((state) => state.multiBase.selectedBase.project_id)
	const bulkDownloadStatus = useSelector((state) => state.downloads.bulk_download)

	//reviews
	const assigneeMap = useSelector((state) => state.review?.assigneeMap)
	const reviewCurrentAsignee = useSelector((state) => state.review?.reviewCurrentAsignee)
	const reviewAssignee = useSelector((state) => state.review?.reviewAssignee)
	const isReviewFormOpen = useSelector((state) => state.review?.isReviewFormOpen)
	const selectedRowFromRedux = useSelector((state) => state.downloads?.selectedDocumentIds)
	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	// Data state
	const [searchDocumentsList, setSearchDocumentslist] = useState({ count: 0, data: [] })
	// State to manage the elements mouseOver
	const [itemId, setItemId] = useState()
	const [currentpage, setCurrentPage] = useState(1)
	const [totalpages, setTotalPages] = useState(1)
	// Get Item Content
	const [item, setItem] = useState({
		idItem: "",
		contentItem: "",
	})
	// Select MouseOver / MouseOut
	const [selectOver, setSelectOver] = useState(false)
	// getModalStyle is not a pure function, we roll the style only on the first render
	const [modalStyle] = useState(getModalStyle)
	const [open, setOpen] = useState(false)
	const [selectIdentify, setSelectIdentify] = useState({
		show: false,
		value: "",
		elementId: "",
		color: "",
	})
	const [selectDateDocument, setSelectDateDocument] = useState({
		show: false,
		date: "",
		elementId: "",
	})
	//Current hightlight text word index
	const [hightlightIndex, setHightlightIndex] = useState(null)

	// Get document content
	const [content, setContent] = useState({
		documentId: "",
		documentText: "",
		documentSubject: "",
		documentFrom: "",
		documentTo: "",
		errorDocumentText: null,
	})

	//Docs to show - Pagination
	const [docsToSHow, setDocsToSHow] = useState({ count: 0, data: [] })
	// BULK BUTTONS
	const [activeCheckbox, setActiveCheckbox] = useState(false)
	// Bulk checked
	const [bulkChecked, setBulkChecked] = useState(new Array(docsToSHow.data.length).fill(false))
	// Documents selected - Bulk download
	const [documentsBulk, setDocumentsBulk] = useState([])
	// All selected
	const [allChecked, setAllChecked] = useState(false)

	const [showingCommentBox, setShowingCommentBox] = useState(false)
	const [showingCommentBoxId, setShowingCommentBoxId] = useState(null)
	const [userSelectedList, setUserSelectedList] = useState([])

	//Docs Comments
	const [comment, setComment] = useState("")
	const [commentList, setCommentList] = useState([])
	const [commentContent, setCommentContent] = useState()

	// Refresh element
	const [idElement, setIdElement] = useState(Math.random())
	const [inputPageNumber, setInputPageNumber] = useState(page)

	// Create tag form popup
	const [showTagForm, setShowTagForm] = useState(false)
	// Email Dialog
	const [emailDialogOpen, setEmailDialogOpen] = useState(false)
	const [emailDailogData, setEmailDailogData] = useState({})
	//Downloa As Dialog
	const [downloadDialogOpen, setDownloadDialogOpen] = useState(false)
	// MultiTag Dialog
	const [multiTagDialogOpen, setMultiTagDialogOpen] = useState(false)
	const [multiTagDialogData, setMultiTagDialogData] = useState([])
	const [currFileId, setCurrFileId] = useState(null)
	// Tagged date update dialog
	const [taggedDateDialogOpen, setTaggedDateDialogOpen] = useState(false)
	const [tagDatedDialogData, setTagDatedDialogData] = useState({})
	/* ******************* END REACT STATES ******************* */

	const debouncedTerm = useDebounce(inputPageNumber, PAGINATION_DELAY)

	/* ******************* VARIABLES ******************* */
	//DB click control
	let timer = 0
	let delay = 200
	let prevent = false
	// Pagination
	let elementsPerPage = 20
	let calcTotalPages = Math.ceil(searchDocumentsList.data?.length / elementsPerPage)
	const filtersObject = { ...filtersButton, ...filterList }
	const wrapperRef = useRef(null)
	let dispatchDocs = null
	/* ******************* END VARIABLES ******************* */

	/* ******************* USE-EFFECTS ******************* */

	useEffect(() => {
		if (debouncedTerm !== "" && Number(debouncedTerm) >= 1 && Number(debouncedTerm) <= pageCount) setPage(Number(debouncedTerm))
		else {
			setInputPageNumber(page)
		}
	}, [debouncedTerm])

	useEffect(() => {
		setActiveCheckbox(false)
	}, [selectedBaseId])

	//Reload comments when updating
	useEffect(() => {
		if (updateCommentsRequest === true) {
			updateCommentList(showingCommentBoxId)
			dispatch(documentsActions.updateCommentRequest(false))
		}
	}, [updateCommentsRequest])

	const updateCommentList = async (docId) => {
		//get comment list form backend
		//setCommentList([]);
		//const response = await documentsService.getComments(docId);
		const response = await axios.get(`/documents/comments/${docId}`)
		if (response.hasOwnProperty("data") && response.data.hasOwnProperty("data")) {
			setCommentList(response.data.data)
			dispatch(documentsActions.storeCommentCountRequest(docId, response.data.data.length))
		}

		return
	}

	useEffect(() => {
		if (searchDocumentsList.count > 0) {
			let auxToShow = {
				count: searchDocumentsList.count,
				data: searchDocumentsList.data,
			}
			// auxToShow = {
			// 	count: auxToShow.count,
			// 	data: auxToShow.data.slice(20 * (currentpage - 1), 21 * currentpage - currentpage),
			// }
			setDocsToSHow({
				count: auxToShow.count,
				data: auxToShow.data,
			})
		} else {
			setDocsToSHow({
				count: 0,
				data: [],
			})
		}
	}, [searchDocumentsList])

	useEffect(() => {
		setDocumentslist(searchDocumentsList)
		calcTotalPages = Math.ceil(searchDocumentsList.data?.length / elementsPerPage)
	}, [searchDocumentsList])

	//Close date modal when success
	useEffect(() => {
		if (alert && alert.type === "modal" && alert.class === "alert alert-success") {
			if (selectDateDocument.date) {
				setItem({ ...item, date: new Date(selectDateDocument.date).getTime() })
			}
			setSelectDateDocument({
				show: false,
			})
		}
	}, [alert])

	//Reload documents
	// useEffect(() => {
	//     // dispatch(loadDocumentsOfConcept(filtersObject));
	//     dispatch(loadDocumentsOfConcept(filtersObject));
	// }, [conceptsOfSearch]);

	useEffect(() => {
		//filtering()
		return
	}, [allDocuments, elementsFilter, filtersButton, filterList, filterDate])

	useEffect(() => {
		//To do : To fix filter change which should be specific to date filter
		setInputPageNumber(1) //if chnage in filter will reset the pageNumber
	}, [filterList, filtersButton.fromDate, filtersButton.toDate])

	useEffect(() => {
		if (needToFilter === true) {
			//filtering()
			setNeedToFilter(false)
		}

		return
	}, [needToFilter])

	useEffect(() => {
		dispatch(tagButtonClickedReset())
	}, [])

	useEffect(() => {
		if (isAllDocsViewSelected) {
			setSearchDocumentslist(allDocuments)
		} else {
			setSearchDocumentslist(conceptDocs)
		}
		//filtering()
		return
	}, [allDocuments, conceptDocs])

	useEffect(() => {
		setTotalPages(calcTotalPages)
		setCurrentPage(1)
		return
	}, [calcTotalPages])

	//Update number of elements shown in list
	useEffect(() => {
		var elements = document.getElementsByClassName("conceptLoaded")
		for (var i = 0; i < elements.length; i++) {
			if (elements[i].classList.contains("conceptLoaded_page_" + currentpage) === true) {
				elements[i].classList.remove("hidePage")
			} else {
				elements[i].classList.add("hidePage")
			}
		}
	}, [currentpage])

	useEffect(() => {
		if (selectIdentify.elementId !== undefined && selectIdentify.elementId !== "") {
			try {
				document.getElementById(`doc_id_${selectIdentify.elementId}`).classList.remove("text-warning")
				document.getElementById(`doc_id_${selectIdentify.elementId}`).classList.remove("text-danger")
				document.getElementById(`doc_id_${selectIdentify.elementId}`).classList.remove("text-success")
				document.getElementById(`doc_id_${selectIdentify.elementId}`).classList.remove("circleHidden")
				document.getElementById(`doc_id_${selectIdentify.elementId}`).style.backgroundColor = operationsHelper.getTagColor(
					selectIdentify.value,
					tagsApi
				)
				document.getElementById(`doc_id_${selectIdentify.elementId}`).style.display = "block"
			} catch (e) {}
		}
	}, [selectIdentify])

	useEffect(() => {
		if (viewDocument?.id || viewDocument?.document_id) {
			setItem({
				idItem: viewDocument.id ? viewDocument.id : viewDocument.document_id,
				contentItem: viewDocument.content,
				source: viewDocument.source,
				title: viewDocument.title,
				comments_count: viewDocument.comments_count,
				date:
					viewDocument.hasOwnProperty("tagged_date") &&
					viewDocument.tagged_date !== null &&
					viewDocument.tagged_date !== undefined
						? viewDocument.tagged_date
						: Math.floor(Date.now() / 1000),
				file_name: viewDocument.file_name,
				pageNum: viewDocument.hasOwnProperty("page_number") ? viewDocument.page_number : 1,
				totalPages: viewDocument.hasOwnProperty("total_page_number") ? viewDocument.total_page_number : 1,
			})

			getDocumentContent(viewDocument.id, viewDocument.content)
			//updateCommentList(item.id);
			setCommentList(viewDocument.comments)
			//dispatch(documentsActions.storeCommentCountRequest(viewDocument.id, viewDocument.comments.length));
			setShowingCommentBoxId(viewDocument.id)

			//update metadata in the list
			const data = {}
			data[METADATA.TAG] = viewDocument.tags?.id || ""
			data[METADATA.COMMENT] = viewDocument.comments_count
			data[METADATA.DATE] = viewDocument.tagged_date

			dispatch(updateMetadata({ id: viewDocument?.id, data: data }))
		}
	}, [viewDocument])

	/* ******************* END USE-EFFECTS ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */

	//Previous Page
	const prevPage = () => {
		const newCurrentPage = currentpage - 1
		if (newCurrentPage === 0) return
		setCurrentPage(newCurrentPage)
	}

	// Next Page
	const nextPage = () => {
		const newCurrentPage = currentpage + 1
		if (newCurrentPage > totalpages) return
		setCurrentPage(newCurrentPage)
	}

	// MODAL ELEMENT
	function rand() {
		return Math.round(Math.random() * 20) - 10
	}

	function getModalStyle() {
		const top = 0
		const left = 60

		return {
			top: `${top}%`,
			left: `${left}%`,
			//transform: `translate(-${top}%, -${left}%)`,
		}
	}

	const useStyles = makeStyles((theme) => ({
		paper: {
			position: "absolute",
			width: "40%",
			height: "100%",
			backgroundColor: "#9dddd6",
			//border: '2px solid #000',
			boxShadow: theme.shadows[5],
			padding: "16px 15px 24px",
		},
		emailDialogBox: {
			"& p": {
				paddingBottom: 2,
				...theme.typography.body2,
			},
			"& h6": {
				paddingBottom: 4,
				...theme.typography.body2,
				fontSize: "12px",
			},
		},
	}))

	const handleOpen = () => {
		setOpen(true)
		setHightlightIndex(null)
	}

	const handleClose = () => {
		setOpen(false)
		setSelectIdentify({ ...selectIdentify, show: false })
		setSelectDateDocument({ ...selectDateDocument, show: false })
		setHightlightIndex(null)
		setShowingCommentBoxId(null)
	}

	// SELECT IDENTIFY
	const showSelectIdentify = (e) => {
		e.preventDefault()
		if (!selectIdentify.show) {
			setSelectIdentify({
				show: true,
			})
			setSelectDateDocument({
				show: false,
			})
		} else {
			setSelectIdentify({
				show: false,
			})
		}
	}

	const updateSelectIdentify = (tag_id, elementId) => {
		dispatch(documentsActions.setPriorityAction(elementId, tag_id))
		setSelectIdentify({
			value: tag_id,
			elementId: elementId,
		})
		//(currentConcept.description, currentConcept.ext_id, filtersObject));
	}

	// SELECT DATE DOCUMENT
	const showSelectDateDocument = (e) => {
		e.preventDefault()
		if (!selectDateDocument.show) {
			setSelectDateDocument({
				show: true,
			})
			setSelectIdentify({
				show: false,
			})
		} else {
			setSelectDateDocument({
				show: false,
			})
		}
	}

	const updateSelectDateDocument = (e, docId) => {
		e.preventDefault()
		setSelectDateDocument({
			show: true,
			date: e.target.value,
			elementId: docId,
		})
	}

	const updateDateDocument = (e) => {
		e.preventDefault()
		dispatch(documentsActions.setDocumentDateAction(selectDateDocument.elementId, selectDateDocument.date))

		//update metadata in the list
		const data = {}
		data[METADATA.DATE] = selectDateDocument.date
		dispatch(updateMetadata({ id: selectDateDocument.elementId, data: data }))
	}

	// Get dates with yellow marked background
	const maskHightlight = (text, id) => {
		let markedText = operationsHelper.cleanHTMLTags(text)
		if (filtersButton.emails === true) {
			markedText = operationsHelper.highlightEmails(markedText, id)
		}

		//Concepts and search terms highlighting is not applicable in View all documents therefore commenting this code for now
		// if (filtersButton.concepts === true){
		//     //Hay que checkear esto, porque ahora conceptsOfSearch es 1 json
		//     markedText = operationsHelper.highlightConcepts(markedText, conceptsOfSearch,id);
		// }

		if (filtersButton.dates !== false) {
			markedText = operationsHelper.hightlightDates(markedText, id)
		}

		if (filtersButton.searchWord.length !== 0 && filtersButton.specificWord === true) {
			markedText = operationsHelper.highlightWords(markedText, filtersButton.searchWord, id)
		}

		return { __html: markedText }
	}

	// OUTSIDE ALERTER
	/**
	 * Hook that alerts clicks outside of the passed ref
	 */
	const useOutsideAlerter = (ref) => {
		useEffect(() => {
			/**
			 * Alert if clicked on outside of element
			 */
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setSelectIdentify({ show: false })
					setSelectDateDocument({ show: false })
					setShowTagForm(false)
				}
			}

			// Bind the event listener
			document.addEventListener("mousedown", handleClickOutside)
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener("mousedown", handleClickOutside)
			}
		}, [ref])
	}

	const getDocumentContent = (idDocument, documentContent) => {
		try {
			dataHelper.extractData(documentContent, setContent, allDocuments, idDocument)
		} catch (error) {}
	}

	const handleRecordClick = async (id) => {
		//dispatch(getDocumentsRequest(id))
		dispatch(getDocumentRowClickRequest(id))
	}

	const handleChange = (position) => {
		const updatedCheckedState = bulkChecked.map((item, index) => {
			if (index === position) {
				return !item
			} else {
				return item
			}
		})

		setBulkChecked(updatedCheckedState)
	}

	const handleChangeAll = (active) => {
		if (active) {
			setAllChecked(false)
		} else {
			setAllChecked(true)
		}
	}

	const updateDocumentsBulk = (docId, filename) => {
		let document = {
			id: docId,
			filename: filename,
		}

		let deleteDocument = false
		let indexDoc = ""

		Object.keys(documentsBulk).map((key, index) => {
			if (documentsBulk[key].id === docId) {
				deleteDocument = true
				indexDoc = index
			}
		})

		if (deleteDocument) {
			documentsBulk.splice(indexDoc, 1)
		} else {
			documentsBulk.push(document)
		}
	}

	const selectAllDocs = () => {
		if (allChecked) {
			setBulkChecked(new Array(docsToSHow.data.length).fill(false))

			let deleteDocument = false
			let indexDoc = ""

			docsToSHow.data.map((item, i) => {
				Object.keys(documentsBulk).map((key, index) => {
					if (documentsBulk[key].id === item.id) {
						deleteDocument = true
						indexDoc = index
					}
				})

				if (deleteDocument) {
					documentsBulk.splice(indexDoc, 1)
				}
			})
		} else {
			setBulkChecked(new Array(docsToSHow.data.length).fill(true))

			docsToSHow.data.map((item, i) => {
				let document = {
					id: item.id,
					filename: item.title,
				}
				documentsBulk.push(document)
			})
		}
	}
	/* ******************* END CUSTOM FUNCTIONS ******************* */

	/* ******************* VARIABLES POST INITIALIZATION ******************* */
	const classes = useStyles()
	/* ******************* END VARIABLES POST INITIALIZATION ******************* */

	/* ******************* FUNCTION CALL POST INITIALIZATION ******************* */
	useOutsideAlerter(wrapperRef)
	/* ******************* END FUNCTION CALL POST INITIALIZATION ******************* */

	//Scroll to next hightlight word
	const moveToHightlight = () => {
		try {
			var elementMark = document.getElementsByClassName("mark_element")
			var nextH
			if (hightlightIndex === null) {
				nextH = 0
			} else {
				nextH = (hightlightIndex + 1) % elementMark.length
			}
			setHightlightIndex(nextH)
			document.getElementById("divModal").scrollTop = elementMark[nextH].offsetTop - 100
		} catch (e) {}
	}

	const handleInputPageBlur = (e) => {
		const pageNumberValue = Math.sign(e.target.value)
		if (!pageNumberValue || Number(e.target.value) > pageCount) {
			setInputPageNumber(page)
		}
	}

	const updateCommentCount = (id, commentCount) => {
		const data = {}
		data[METADATA.COMMENT] = commentCount
		dispatch(updateMetadata({ id: id, data: data }))
	}

	const openCreateTag = (e) => {
		setShowTagForm(!showTagForm)
		//e.preventDefault()
		e.stopPropagation()
	}

	const getTags = (params) => {
		return (
			<MultiTagView
				view={LIST_VIEW}
				fileData={{ id: params?.row?.id, file_name: params?.row?.file_name, tags: params?.row?.tags }}
				tagState={{
					multiTagDialogData,
					multiTagDialogOpen,
					selectedSearch,
					setCurrFileId,
					setMultiTagDialogData,
					setMultiTagDialogOpen,
				}}
			/>
		)
	}

	const handlePageChange = (newPage) => {
		setPage(newPage)
	}

	const handlePageSizeChange = (newPageSize) => {
		setRecordsPerPage(newPageSize)
	}

	const handleSortModelChange = (newSortModel) => {
		if (!_.isEmpty(newSortModel)) {
			if (JSON.stringify(newSortModel) !== JSON.stringify(sortModel)) {
				setSortModel(newSortModel)
			}
		}
	}

	const renderEmailDialog = (params) => {
		return (
			<Typography
				variant="body2"
				onClick={() => {
					setEmailDialogOpen(true)
					setEmailDailogData({
						to: params?.row?.to,
						cc: params?.row?.cc || [],
						bcc: params?.row?.bcc || [],
					})
				}}
				style={{ cursor: "pointer" }}
			>
				{params?.row?.to?.length > 1 ? (
					<>
						{`${params?.row?.to?.[0]}...`}
						<KeyboardArrowDown style={{ marginLeft: "10px" }} />
					</>
				) : (
					params?.row?.to
				)}
			</Typography>
		)
	}

	const renderTagHeader = () => {
		return (
			<Typography variant="subtitle2" component="h2">
				{t("tag.title")}
			</Typography>
		)
	}

	const renderPageNumberHeader = () => {
		return (
			<>
				<Typography variant="subtitle2" component="h2" style={{ display: "flex", justifyContent: "end", width: "100%" }}>
					{t("tableColumns.pages")}
				</Typography>
			</>
		)
	}

	const bulkDownloadEvent = () => {
		//console.log("userSelectedList", userSelectedList)

		//dispatch(documentsActions.downloadMultipleAction(params?.row?.id, params?.row?.file_name, params?.row?.source))
		setDownloadDialogOpen(true)
	}
	const getRows = () => {
		return docsToSHow.count > 0
			? docsToSHow.data.map((docData) => {
					if (docData?.metadata?.source === "email") {
						return {
							...docData,
							id: docData?.file_id,
							subject: docData?.metadata?.subject || "NA",
							title: docData?.metadata?.title || docData?.name || "NA",
							author: docData?.metadata?.from || "NA",
							tags: docData?.tags || "NA",
							tagged_date: docData?.metadata?.tagged_date || "NA",
							view_count: docData?.viewed || 0,
							size: docData?.size || 0,
							comments_count: docData?.comments_count || 0,
							action: "",
							source: docData?.metadata?.source || "NA",
							to: docData?.metadata?.to || "NA",
							from: docData?.metadata?.from || "NA",
							cc: docData?.metadata?.cc || [],
							bcc: docData?.metadata?.bcc || [],
							attachments: docData?.children_files || [],
							reviewed: docData?.reviewed || false,
							pages: docData?.metadata?.total_page_number || 0,
						}
					} else
						return {
							...docData,
							id: docData?.file_id,
							title: docData?.metadata?.title || docData?.name || docData?.metadata?.filename || "NA",
							author: docData?.metadata?.author || "NA",
							tags: docData?.tags || "NA",
							tagged_date: docData?.metadata?.tagged_date || "NA",
							view_count: docData?.viewed || 0,
							size: docData?.size || 0,
							comments_count: docData?.comments_count || 0,
							action: "",
							source: docData?.metadata?.source || "NA",
							attachments: docData?.children_files || [],
							reviewed: docData?.reviewed || false,
							pages: docData?.metadata?.total_page_number || 0,
						}
			  })
			: []
	}

	const fileSelection = (rowId, isChecked) => {
		let assigneeMapClone = _.cloneDeep(assigneeMap)
		if (assigneeMap.has(rowId) && !isChecked) {
			//assigneeMapClone.delete(rowId)
			assigneeMapClone.set(rowId, null)
		} else {
			assigneeMapClone.set(rowId, reviewCurrentAsignee)
		}

		const reviewAssigneeRef = _.cloneDeep(reviewAssignee)

		if (reviewCurrentAsignee) {
			if (isChecked) {
				const newIds = Object.keys(reviewAssigneeRef[reviewCurrentAsignee])?.length
					? [...reviewAssigneeRef[reviewCurrentAsignee]]
					: []
				reviewAssigneeRef[reviewCurrentAsignee] = [...newIds, rowId]
			} else {
				const filterIds = reviewAssigneeRef[reviewCurrentAsignee]?.filter((id) => id !== rowId)
				reviewAssigneeRef[reviewCurrentAsignee] = filterIds
			}
		}

		dispatch(setReviewAssigneeMap(assigneeMapClone))
		dispatch(setReviewAsignee(reviewAssigneeRef))
	}

	const renderTaggedDate = (params) => {
		return <TaggedDate data={params?.row} dialogData={{ taggedDateDialogOpen, setTaggedDateDialogOpen, setTagDatedDialogData }} />
	}

	const rows = getRows()
	return (
		<>
			<Grid container item className={classes.table} justifyContent="space-around" style={{ position: "relative" }}>
				<TableView
					columns={getAllDocumentsTableColumns(
						isEmailType,
						renderTagHeader,
						getTags,
						renderEmailDialog,
						fileSelection,
						rows,
						renderTaggedDate,
						renderPageNumberHeader
					)}
					rows={rows}
					isLoading={isAllDocsViewSelected ? isAlldocsLoading : conceptsDocLoading}
					pageInfo={{
						paginationMode: SERVER_MODE,
						page: page,
						pageSize: recordsPerPage,
						rowsPerPageOptions: PAGE_OPTIONS,
						totalRowCount: isAllDocsViewSelected ? allDocumentsCount : conceptsDocCount,
						handlePageChange,
						handlePageSizeChange,
					}}
					sortInfo={{
						sortingMode: SERVER_MODE,
						sortModel: sortModel,
						onSortModelChange: handleSortModelChange,
					}}
					checkboxSelection={true}
					footerInfo={{
						hideFooter: false,
						hideSelectionCount: true,
						hidePagination: false,
					}}
					topBarInfo={{
						show: true,
						leftSection: `Total documents: ${docsToSHow.count}`,
						rightSection: "",
					}}
					totalCountText={`${t("tableColumns.totalFiles")}: ${docsToSHow?.count}`}
					showDownloadButton={true}
					showColumnsButton={false}
					bulkDownloadEvent={bulkDownloadEvent}
					userSelectedRows={setUserSelectedList}
					bulkDownloadStatus={bulkDownloadStatus}
					toApplyHotKeys={!tagButtonClicked}
					showDuplicate={true}
				/>
				{showTagForm && <CreateTag innerRef={wrapperRef} show={showTagForm} />}
			</Grid>
			<div data-cy="element_modal">
				<DocumentModal
					open={open}
					handleClose={handleClose}
					selectDateDocument={selectDateDocument}
					wrapperRef={wrapperRef}
					updateSelectDateDocument={updateSelectDateDocument}
					updateDateDocument={updateDateDocument}
					updateSelectIdentify={updateSelectIdentify}
					showSelectDateDocument={showSelectDateDocument}
					maskHighlight={maskHightlight}
					moveToHighlight={moveToHightlight}
					updateCommentCount={updateCommentCount}
				/>
			</div>
			<EmailDialog
				open={emailDialogOpen}
				title={t("dialog.email.to")}
				onClose={() => {
					setEmailDialogOpen(false)
				}}
			>
				<Box className={classes.emailDialogBox}>
					{emailDailogData?.to?.map((emailTo, index) => {
						return <Typography key={`emailto-${index}`}>{emailTo}</Typography>
					})}
					{emailDailogData?.cc?.length > 0 && <Typography component="h6">{t("dialog.email.cc")}</Typography>}
					{emailDailogData?.cc?.map((cc, index) => {
						return <Typography key={`cc-${index}`}>{cc}</Typography>
					})}
					{emailDailogData?.bcc?.length > 0 && <Typography component="h6">{t("dialog.email.bcc")}</Typography>}
					{emailDailogData?.bcc?.map((bcc, index) => {
						return <Typography key={`bcc-${index}`}>{bcc}</Typography>
					})}
				</Box>
			</EmailDialog>
			<ShowAllTags
				tagState={{
					multiTagDialogData,
					multiTagDialogOpen,
					currFileId,
					selectedSearch,
					setMultiTagDialogData,
					setMultiTagDialogOpen,
					setCurrFileId,
				}}
			/>
			<DownloadAs
				open={downloadDialogOpen}
				title={t("downloadDialog.title")}
				handleBulkDownload={(source) => {
					const ids = Object.keys(selectedRowFromRedux)
					dispatch(documentsActions.downloadMultipleFileAction(ids, source))
					//dispatch(documentsActions?.downloadMultipleFileAction(userSelectedList, source))
				}}
				onClose={() => {
					setDownloadDialogOpen(false)
				}}
			/>
			<TaggedDateDialog
				open={taggedDateDialogOpen}
				title={t("taggedDateDialog.title")}
				onClose={() => {
					setTaggedDateDialogOpen(false)
				}}
				tagDatedDialogData={tagDatedDialogData}
			/>
		</>
	)
}
